import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import aboutVideo from '../Images/burj-khalifa-skyscraper.mp4'

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: 'easeOut', delay },
  }),
}

export const HomeAboutUs = () => {
  const { t, i18n } = useTranslation()
  const isArabic = (i18n.language || 'ar').startsWith('ar')
  const stats = t('about.stats', { returnObjects: true })

  return (
    <Box sx={{ bgcolor: '#2B2B2B', py: { xs: 10, md: 14 }, overflow: 'hidden' }}>
      <Grid
        container
        spacing={{ xs: 6, md: 10 }}
        alignItems="center"
        sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 3, md: 6 } }}
      >


        {/* النص والإحصائيات */}
        <Grid item xs={12} md={6}>
          <Box
            component={motion.div}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.4 }}
          >
            <Typography
              component={motion.p}
              custom={0}
              variants={fadeUp}
              variant="overline"
              sx={{ color: '#7A2E3A', fontWeight: 700, letterSpacing: 2 }}
            >
              {t('about.eyebrow')}
            </Typography>

            <Typography
              component={motion.h2}
              custom={0.1}
              variants={fadeUp}
              sx={{
                fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
                fontWeight: isArabic ? 700 : 500,
                fontSize: { xs: '2rem', md: '2.75rem' },
                color: '#D9D6CF',
                lineHeight: 1.2,
                mt: 1,
                mb: 3,
              }}
            >
              {t('about.title')}
            </Typography>

            <Typography
              component={motion.p}
              custom={0.2}
              variants={fadeUp}
              sx={{ color: 'rgba(217,214,207,0.75)', lineHeight: 1.9, mb: 6 }}
            >
              {t('about.description')}
            </Typography>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: { xs: 2, sm: 3 },
              }}
            >
              {stats.map((stat, index) => (
                <Box
                  component={motion.div}
                  custom={0.3 + index * 0.1}
                  variants={fadeUp}
                  key={stat.label}
                  sx={{
                    minWidth: 0,
                    borderInlineStart: '2px solid #7A2E3A',
                    pl: isArabic ? 0 : { xs: 1.2, sm: 2 },
                    pr: isArabic ? { xs: 1.2, sm: 2 } : 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
                      fontSize: { xs: '1.3rem', sm: '1.8rem', md: '2.2rem' },
                      color: '#D9D6CF',
                      fontWeight: 600,
                      lineHeight: 1,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    sx={{
                      color: 'rgba(217,214,207,0.6)',
                      fontSize: { xs: '0.7rem', sm: '0.85rem' },
                      mt: 0.5,
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
